import debounce from 'lodash/debounce';

export default {
    name: 'mvtRangeSlider',
    props: {
        modelValue: {
            type: Object,
            default: {},
            required: false,
        },
        data: {
            type: Array,
            required: true,
        },
        options: {
            type: Object,
            default: () => {
                return {
                    mapping: {
                        min: 'min',
                        max: 'max',
                    },
                    defaultValue: ['', ''],
                    placeholderMin: 'No Min',
                    placeholderMax: 'No Max',
                };
            },
        },
    },

    computed: {
        rangeSliderStepData() {
            let length = this.rangeSliderData.length;
            return Array.from(Array(length).keys());
        },
        rangeSliderData() {
            let firstItem = {
                value: this.options.defaultValue[0],
                text: this.options.placeholderMin,
            };
            let lastItem = {
                value: this.options.defaultValue[1],
                text: this.options.placeholderMax,
            };
            return [firstItem, ...this.data, lastItem];
        },
        minIndex() {
            return 0;
        },
        maxIndex() {
            return this.rangeSliderStepData.length - 1;
        },
        _value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        _valueMaxIndex: {
            get() {
                let max = this._value[this.options.mapping.max];
                if (max == 0 || max == this.options.defaultValue[1]) {
                    return this.maxIndex;
                } else {
                    for (let i = this.data.length - 1; i >= 0; i--) {
                        if (this.data[i].value && this.data[i].value <= max) {
                            // return Math.max(i, this._valueMinIndex + 1);
                            return i + 1;
                        }
                    }
                }
            },
            set(value) {
                let newItem = {};
                newItem[this.options.mapping.min] = this.rangeSliderData[this._valueMinIndex].value;
                if (value == 0 || value == this.maxIndex) {
                    newItem[this.options.mapping.max] = this.options.defaultValue[1];
                } else {
                    newItem[this.options.mapping.max] = this.rangeSliderData[value].value;
                }
                this._value = newItem;
            },
        },
        _valueMinIndex: {
            get() {
                let min = this._value[this.options.mapping.min];
                if (min == 0 || min == this.options.defaultValue[0]) {
                    return this.minIndex;
                } else {
                    for (let i = 0; i < this.data.length; i++) {
                        if (this.data[i].value && this.data[i].value >= min) {
                            return i + 1;
                        }
                    }
                }
            },
            set(value) {
                let newItem = {};
                newItem[this.options.mapping.max] = this.rangeSliderData[this._valueMaxIndex].value;
                if (value == 0 || value == this.minIndex) {
                    newItem[this.options.mapping.min] = this.options.defaultValue[0];
                } else {
                    newItem[this.options.mapping.min] = this.rangeSliderData[value].value;
                }
                this._value = newItem;
            },
        },
    },
    methods: {
        onChangeMinIndex() {
            let fromSlider = this.$refs.min;
            let toSlider = this.$refs.max;
            const [from, to] = this.getParsed(fromSlider, toSlider);
            this.fillSlider(fromSlider, toSlider, 'var(--mvt-rangeslider-color)', 'var(--mvt-rangeslider-color-active)', toSlider);
            if (from > to) {
                fromSlider.value = to;
                this._valueMinIndex = to;
            } else {
                this._valueMinIndex = from;
            }
        },

        onChangeMaxIndex() {
            let fromSlider = this.$refs.min;
            let toSlider = this.$refs.max;
            const [from, to] = this.getParsed(fromSlider, toSlider);
            this.fillSlider(fromSlider, toSlider, 'var(--mvt-rangeslider-color)', 'var(--mvt-rangeslider-color-active)', toSlider);
            this.setToggleAccessible(toSlider);
            if (from <= to) {
                toSlider.value = to;
                this._valueMaxIndex = to;
            } else {
                toSlider.value = from;
                this._valueMaxIndex = from;
            }
        },

        getParsed(currentFrom, currentTo) {
            const from = parseInt(currentFrom.value, 10);
            const to = parseInt(currentTo.value, 10);
            return [from, to];
        },

        fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
            const rangeDistance = to.max - to.min;
            const fromPosition = from.value - to.min;
            const toPosition = to.value - to.min;
            controlSlider.style.background = `linear-gradient(
              to right,
              ${sliderColor} 0%,
              ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
              ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
              ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
              ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
              ${sliderColor} 100%)`;
        },
        setToggleAccessible(currentTarget) {
            const toSlider = this.$refs.max;
            if (Number(currentTarget.value) <= 0) {
                toSlider.style.zIndex = 2;
            } else {
                toSlider.style.zIndex = 0;
            }
        },
        resetUI() {
            this.$refs.min.value = 0;
            this.$refs.max.value = this.maxIndex;
            this.fillSlider(this.$refs.min, this.$refs.max, 'var(--mvt-rangeslider-color)', 'var(--mvt-rangeslider-color-active)', this.$refs.max);
            this.setToggleAccessible(this.$refs.max);
        },
    },
    watch: {
        _value() {
            debounce(() => {
                this.fillSlider(this.$refs.min, this.$refs.max, 'var(--mvt-rangeslider-color)', 'var(--mvt-rangeslider-color-active)', this.$refs.max);
            }, 100)();
        },
        maxIndex(newVal, oldVal) {
            if (newVal !== oldVal) {
                debounce(() => {
                    this.resetUI();
                }, 100)();
            }
        },
    },
    mounted() {
        setTimeout(() => {
            this.fillSlider(this.$refs.min, this.$refs.max, 'var(--mvt-rangeslider-color)', 'var(--mvt-rangeslider-color-active)', this.$refs.max);
        }, 100);
    },
};
